import React from 'react';

import ArtworkInfo from '../ArtworkInfo';
import OwnerInfoArtistCreateCer from '../OwnerInfoArtistCreateCer';

const UpdateCertificateInfo = ({ artwork, isPending, certificateFormState }) => {
  return (
    <>
      {!isPending && (
        <ArtworkInfo
          artwork={artwork}
          certificateFormState={certificateFormState}
        />
      )}
      <OwnerInfoArtistCreateCer ownerHookForm={certificateFormState} />
    </>
  );
};

export default UpdateCertificateInfo;
